import * as React from "react";
// import { pure } from 'recompose'
import * as Utils from "@Cyclope-Utils/index";
import * as i18next from "i18next";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { Elem, extractIncidentSequence } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name i18next
   * @infos "https://reactjs.org"
   */
  return (
    <section className="arrayContent">
      <span className="arraysContentSpanAuto" style={{ width: "11%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p style={{ cursor: "default" }}>{!!Elem && Elem.id}</p>
          </div>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "26%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p style={{ cursor: "default", width: "300px" }}>
              {!!Elem && Utils.localDateFrSecondFormat(Elem.raisedAt)}
            </p>
          </div>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "26%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p style={{ cursor: "default", width: "300px" }}>
              {!!Elem && Elem.camera.code}
            </p>
          </div>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "26%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p style={{ cursor: "default", width: "300px" }}>
              {!!Elem && i18next.t(`${Elem.rwAlarmCode}`)}
            </p>
          </div>
        </div>
      </span>
      <span className="arraysContentSpanAuto" style={{ width: "11%" }}>
        <div className="arraysContentContenair">
          <div className="arrayContentInfos" style={{ cursor: "pointer" }}>
            <p
              style={{ cursor: "pointer" }}
              className="arraysAction"
              onClick={extractIncidentSequence}
            >
              {" "}
              {i18next.t("extraire")}
            </p>
          </div>
        </div>
      </span>
    </section>
  );
};

Component.defaultProps = {};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  extractIncidentSequence?: any;
  Elem?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/box/tools/incident/component.tsx